export const CONTRACTOR_REGISTRATION_CONFIG = {
  management: {
    apiBase: "SLN/Management/ContractorRegistration",
    listPath: "/SLN/Management/ContractorRegistration",
    reviewNotesLabel: "یادداشت بررسی / توضیحات مدیر",
  },
  solarentOperator: {
    apiBase: "SLN/SolarentOperator/ContractorRegistration",
    listPath: "/SLN/SolarentOperator/ContractorRegistration",
    reviewNotesLabel: "یادداشت بررسی / توضیحات کارشناس",
  },
};
